import PropTypes from 'prop-types';
import {Enums} from '_app/utils';

const fileTypes = Enums.getType('fileTypes');

export default PropTypes.shape({
	createDate: PropTypes.instanceOf(Date),
	id: PropTypes.number,
	mediaID: PropTypes.number,
	label: PropTypes.string,
	downloadLink: PropTypes.string,
	fileName: PropTypes.string,
	fileType: PropTypes.string,
	viewURL: PropTypes.string,
	version: PropTypes.number,
	type: PropTypes.oneOf([
		fileTypes.OTHER,
		fileTypes.STORYBOARD,
		fileTypes.SOURCES,
		fileTypes.TRANSCRIPT,
		fileTypes.FINRA,
		fileTypes.COMPLIANCEVIDEO
	])
});